import { ReactElement } from "react";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import { composeServerSideProps } from "next-composition";
import { withTranslations } from "../../../server/ssrprops/withTranslations";
import { useTranslation } from "../../../fe-ui/hooks/use-translation";
import { LandingFactoid } from "../../../ui/components/LandingFactoid/LandingFactoid";
import { LandingFactoidLikeFeature } from "../../../ui/components/LandingFactoidLikeFeature/LandingFactoidLikeFeature";

import { LandingVector } from "../../../ui/components/LandingVector/LandingVector";
import { LandingApplyLayout } from "../../../ui/layouts/LandingApplyLayout/LandingApplyLayout";
import { LandingApplyBanner } from "../../../ui/components/LandingApplyBanner/LandingApplyBanner";
import { withSeoSsrProps } from "../../../server/ssrprops/withSeoSsrProps";

const ApplyTrustPage = () => {
  const t = useTranslation();

  return (
    <>
      <LandingApplyBanner />

      <Box component={Typography} sx={{ textAlign: "center" }} variant="h1">
        {t("apply_trust_title_main")}
      </Box>

      <Container sx={{ py: 2.5, my: 2 }}>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <LandingFactoid
              valueVariant="h3"
              text={t("apply_trust_factoid_comission_title")}
              value={t("apply_trust_factoid_comission_value")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoid
              tooltipText="Seaya выплачивает подоходный налог в государственную казну автоматически."
              text={t("apply_trust_factoid_tax_title")}
              value={t("apply_trust_factoid_tax_value")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoid
              valueVariant="h3"
              text={t("apply_trust_factoid_fee_title")}
              value={t("apply_trust_factoid_fee_value")}
              helpText={t("apply_trust_factoid_fee_help")}
            />
          </Grid>
        </Grid>
      </Container>

      <Box component={Typography} sx={{ textAlign: "center" }} variant="h2">
        {t("apply_trust_title_features")}
      </Box>

      <Container sx={{ py: 2.5, my: 4 }}>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_1_title")}
              description={t("apply_trust_feature_1_text")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_2_title")}
              description={t("apply_trust_feature_2_text")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_3_title")}
              description={t("apply_trust_feature_3_text")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_4_title")}
              description={t("apply_trust_feature_4_text")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_5_title")}
              description={t("apply_trust_feature_5_text")}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <LandingFactoidLikeFeature
              title={t("apply_trust_feature_6_title")}
              description={t("apply_trust_feature_6_text")}
            />
          </Grid>
        </Grid>
      </Container>

      <Box component={Typography} sx={{ textAlign: "center" }} variant="h2">
        {t("apply_trust_title_howto")}
      </Box>

      <Container sx={{ py: 2.5, my: 4 }}>
        <LandingVector
          items={[
            t.rich("apply_private_signup_steps_1", {
              link: (children) => <Link>{children}</Link>,
            }),
            t("apply_private_signup_steps_2"),
            t("apply_trust_signup_steps_3"),
            t("apply_trust_signup_steps_4"),
          ]}
        />
      </Container>
    </>
  );
};

ApplyTrustPage.getLayout = (page: ReactElement) => <LandingApplyLayout>{page}</LandingApplyLayout>;

export const getServerSideProps = composeServerSideProps({
  use: [withTranslations, withSeoSsrProps],
});

export default ApplyTrustPage;
